import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faPlus,
  faCloudDownload,
  faList,
  faProjectDiagram,
  faUsers,
  faSignOutAlt,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import LotusIcon from "./LotusIcon";

const Navigation = () => {
  const { isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <Navbar expand="lg" className="App-header">
      <Container fluid>
        <Navbar.Brand as={Link} to="/dashboard" className="lotus-brand">
          <LotusIcon className="lotus-icon me-2" size={28} />
          <span>Lotus</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            {isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/dashboard" className="App-link">
                  Dashboard
                </Nav.Link>
                <Nav.Link as={Link} to="/meetings" className="App-link">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                  Meetings
                </Nav.Link>
                <Nav.Link as={Link} to="/tasks" className="App-link">
                  <FontAwesomeIcon icon={faList} className="me-1" /> Tasks
                </Nav.Link>
                <Nav.Link as={Link} to="/projects" className="App-link">
                  <FontAwesomeIcon icon={faProjectDiagram} className="me-1" />{" "}
                  Projects
                </Nav.Link>
                <Nav.Link as={Link} to="/members" className="App-link">
                  <FontAwesomeIcon icon={faUsers} className="me-1" /> Members
                </Nav.Link>
                <Nav.Link as={Link} to="/settings" className="App-link">
                  <FontAwesomeIcon icon={faCog} className="me-1" /> Settings
                </Nav.Link>
                <Nav.Link
                  href="https://drive.google.com/drive/folders/15Dy4AwCIVdDdH4h6oRf7Hvxf9uHIiQG7?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="App-link"
                  style={{ fontWeight: "bold", color: "#d4af37" }}
                >
                  <FontAwesomeIcon icon={faCloudDownload} className="me-1" />
                  Google Drive
                </Nav.Link>
                <Nav.Link onClick={handleLogout} className="App-link">
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-1" />{" "}
                  Logout
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" className="App-link">
                  Login
                </Nav.Link>
                <Nav.Link as={Link} to="/register" className="App-link">
                  Register
                </Nav.Link>
                <Nav.Link
                  href="https://drive.google.com/drive/folders/15Dy4AwCIVdDdH4h6oRf7Hvxf9uHIiQG7?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="App-link"
                  style={{ fontWeight: "bold", color: "#d4af37" }}
                >
                  <FontAwesomeIcon icon={faCloudDownload} className="me-1" />
                  Google Drive
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
